import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { LinearProgress, Typography, InputLabel } from "@mui/material";
import Box from "@mui/material/Box";
import { generateHtmlReport } from "../utils/helper";
import { Select, MenuItem, FormControl } from "@mui/material";

import { useNotification } from "../../../hooks";
import { useGetCollections, useGetTestCasesByEndpoint } from "../../../useQuery";
import apiFetch from "../../../utils/apiFetch";

import { API_BACKEND_URL } from "../../../Config/Config";
import ConstructUrl from "../MainContent/ConstructUrl";
import {
  useFetchLatestResults,
  useFindTestCasesByPriority,
  useFindTestCasesByType,
  useFindTestCasesByCollection,
} from "../../../useQuery";
import BulkApiTester from "../MainContent/BulkApiTester";
import TestCasesTable from "../MainContent/TestCasesTable";
import TestCaseExcelPanel from "../MainContent/TestCaseExcelPanel";
import { Loader2 } from "../MainContent/Loader2";

const matchesExpectedStatus = (actualStatus, expectedStatusCode) => {
  const expectedCodes = String(expectedStatusCode ?? "")
    .split(",")
    .map((code) => parseInt(code.trim(), 10))
    .filter((code) => !Number.isNaN(code));
  return expectedCodes.includes(actualStatus);
};

const ExecutionTab = () => {
  const notify = useNotification();
  const [testResults, setTestResults] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const [testReport, setTestReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentTest, setCurrentTest] = useState("");
  const [selectedTestCases, setSelectedTestCases] = useState([]);
  const [allData, setAllTestCases] = useState(null);
  const [options, setoptions] = useState(null);
  const [testCasesCount, setTestCasesCount] = useState(null);
  const [endCase, setEndcase] = useState(null);
  const [status, setStatus] = useState({ currentEndpoint: null, isGenerating: false });
  const previousEndpointRef = useRef(null);
  const [shouldPoll, setShouldPoll] = useState(true);
  const [baseUrl, setBaseUrl] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState(""); //(priority or type or collection)
  const [collectionfilter, setcollectionfilter] = useState("");
  const [endPoint, setEndpoint] = useState("");
  const [filteredTestCases, setFilteredTestCases] = useState(null);
  const [runbutton, setRunbutton] = useState("Run All Tests");
  const userDetails = localStorage.getItem("userDetail");
  const user = JSON.parse(userDetails);
  const [cache, setCache] = useState({ lastfilter: "", lastdata: [] });

  const {
    data: latestResults,
    isError,
    isLoading: queryLoading,
    refetch,
  } = useFetchLatestResults({
    enabled: true,
  });

  const {
    data: priorityTestCases,
    isLoading: priorityLoading,
    refetch: refetchPriority,
  } = useFindTestCasesByPriority({ enabled: false }, searchQuery);

  const {
    data: typeTestCases,
    isLoading: typeLoading,
    refetch: refetchTypeCases,
  } = useFindTestCasesByType({ enabled: false }, searchQuery);

  const {
    data: collectionTestCases,
    isLoading: collectionLoading,
    refetch: refetchCollectionCases,
  } = useFindTestCasesByCollection({ enabled: false }, collectionfilter);

  const { mutate: fetchTestCases, isPending: loadingTestCases } = useGetTestCasesByEndpoint({
    onSuccess: (data, variables) => {
      setCache((prev) => ({ ...prev, lastdata: data }));
      setFilteredTestCases(data);
    },
    onError: (error) => {
      notify("Error fetching test cases", "error");
    },
  });

  useEffect(() => {
    if (priorityTestCases && searchType === "priority") {
      setFilteredTestCases(priorityTestCases);
    }
  }, [priorityTestCases, searchType]);

  useEffect(() => {
    if (typeTestCases && searchType === "type") {
      setFilteredTestCases(typeTestCases);
    }
  }, [typeTestCases, searchType]);
  useEffect(() => {
    if (isLoading) {
      setRunbutton("Running Tests...");
    } else if (selectedTestCases.length !== 0) {
      setRunbutton("Run Selected Case");
    } else setRunbutton(`Run All Tests`);
  }, [isLoading, selectedTestCases]);

  useEffect(() => {
    if (collectionTestCases && searchType === "collection") {
      setFilteredTestCases(collectionTestCases);
    }
  }, [collectionTestCases, searchType]);

  const handleSearch = () => {
    let results = [];
    let data = filteredTestCases;
    if (cache.lastfilter === searchType) {
      data = cache.lastdata;
    }
    if (searchQuery.trim()) {
      if (collectionfilter) {
        if (searchType === "priority") {
          results = data.filter((obj) => {
            return obj.priority?.toUpperCase().includes(searchQuery.toUpperCase());
          });
        } else if (searchType === "type") {
          results = data.filter((obj) => {
            return obj.testType?.toUpperCase().includes(searchQuery.toUpperCase());
          });
        } else if (searchType === "Code") {
          results = data.filter((obj) => {
            return obj.expectedStatusCode === searchQuery;
          });
        } else if (searchType === "Tags") {
          results = data.filter((obj) => {
            return obj.tags?.toUpperCase().includes(searchQuery.toUpperCase());
          });
        } else if (searchType === "Methods") {
          results = data.filter((obj) => {
            return obj.httpMethod?.toUpperCase().includes(searchQuery.toUpperCase());
          });
        }
      } else {
        console.log("sdffsvs");
        if (searchType === "priority") {
          refetchPriority();
        } else if (searchType === "type") {
          refetchTypeCases();
        } else if (searchType === "collection") {
          refetchCollectionCases();
        } else if (searchType === "Methods") {
          results = allData.filter((obj) => {
            return obj.httpMethod?.toUpperCase().includes(searchQuery.toUpperCase());
          });
        }
      }
      setCache((prev) => ({ ...prev, lastfilter: searchType }));
      setFilteredTestCases(results);
    } else {
      setFilteredTestCases(null);
    }
  };

  const clearSearch = () => {
    setEndpoint("");
    setSearchQuery("");
    setFilteredTestCases(null);
    setcollectionfilter("");
    setSearchType("");
  };

  const isSearchLoading = priorityLoading || typeLoading || collectionLoading;

  const loaderStyles = `
    .loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 40;
    }

    .content-container {
      position: relative;
      flex-grow: 1;
      height: calc(100vh - 48px);
    }
  `;

  useEffect(() => {
    if (latestResults) {
      try {
        setBaseUrl(latestResults?.collections[0]?.baseurl);
      } catch (error) {
        console.error("Error parsing response:", error);
      }
    }
  }, [latestResults]);

  useEffect(() => {
    fetchAllTestCases();
  }, []);

  useEffect(() => {
    const statusInterval = setInterval(() => {
      axios
        .get(`${API_BACKEND_URL}/testcase/status?companyid=${user.companyid}`)
        .then((response) => {
          const newStatus = response.data;
          setStatus(newStatus);

          if (
            newStatus.currentEndpoint &&
            newStatus.currentEndpoint !== previousEndpointRef.current
          ) {
            previousEndpointRef.current = newStatus.currentEndpoint;
            fetchAllTestCases();
          }

          if (allData != null && !newStatus.isGenerating) {
            clearInterval(statusInterval);
            fetchAllTestCases();
          }
        })
        .catch((error) => console.error("Error fetching generation status:", error));
    }, 5000);

    return () => clearInterval(statusInterval);
  }, [allData]);

  const fetchAllTestCases = async () => {
    try {
      const response = await axios.get(
        `${API_BACKEND_URL}/testcase/all?companyid=${user.companyid}`,
      );
      setAllTestCases(response.data);
      setTestCasesCount(response.data.length);
      setoptions(filteropt(response.data));
    } catch (error) {
      console.error("Error fetching test cases:", error);
    }
  };
  function filteropt(data) {
    const priority = new Set();
    const testType = new Set();
    const expectedStatusCode = new Set();
    const tags = new Set();

    for (const row of data) {
      priority.add(row.priority);
      testType.add(row.testType);
      expectedStatusCode.add(row.expectedStatusCode);
      tags.add(row.tags);
    }
    return {
      priority: Array.from(priority),
      type: Array.from(testType),
      Code: Array.from(expectedStatusCode),
      Tags: Array.from(tags),
      Methods: ["GET", "POST", "PUT", "DELETE"],
    };
  }

  const handlTestCaseSelect = (testcase) => {
    setSelectedTestCases((prev) => {
      const isAlreadySelected = prev.some((tc) => tc.id === testcase.id);

      if (isAlreadySelected) {
        return prev.filter((tc) => tc.id !== testcase.id);
      } else {
        return [...prev, testcase];
      }
    });
  };

  const handleExecuteSelected = () => {
    if (selectedTestCases.length > 0) {
      handleBulkRequests(selectedTestCases);
    }
  };

  const handleMarkAsReviewed = async (selectedTestCases) => {
    const ids = selectedTestCases.map((item) => item.id);
    try {
      const response = await axios.put(
        `${API_BACKEND_URL}/testcase/review`,
        ids,
        {
          params: {
            companyid: user.companyid,
            token: user.token,
          },
        },
        { headers: { "Content-Type": "application/json" } },
      );

      if (response.status === 200) {
        notify("Selected test cases marked as reviewed", "success");
      } else {
        notify("Failed to mark selected test cases as reviewed", "error");
      }
    } catch (error) {
      console.error("Error while marking test cases as reviewed:", error);
    }
    setSelectedTestCases([]);
  };

  const handleSaveTestCase = (testCaseId, updatedData) => {
    // console.log("Saving test case:", testCaseId, updatedData);
  };

  const handleTestComplete = (results, reportUrl) => {
    setTestResults(results);
    setShowTable(false);
    setTestReport(reportUrl);
  };

  const storeTestCaseResult = async (result) => {
    try {
      const response = await axios.post(`${API_BACKEND_URL}/testcase_summary`, result, {
        params: {
          companyid: user.companyid,
          token: user.token,
        },
      });
      if (!response.ok) {
        console.error("Error sending results to API:", response.statusText);
      } else {
        console.log("Results successfully sent to API");
      }
    } catch (error) {
      console.error("Error while sending results to API:", error.message);
    }
  };

  const handleBulkRequests = async (data) => {
    let testCases = data;
    if (selectedTestCases.length !== 0) {
      testCases = selectedTestCases;
    } else if (filteredTestCases !== null) {
      testCases = filteredTestCases;
    }
    if (testCases && testCases.length > 0) {
      setShouldPoll(false);
      setIsLoading(true);
      const results = [];

      try {
        for (let i = 0; i < testCases.length; i++) {
          const testCase = testCases[i];
          setProgress(Math.round((i / testCases.length) * 100));
          setCurrentTest(testCase.testCase);

          const { endpoint = "", httpMethod } = testCase;

          // Null or undefined check for endpoint
          if (!endpoint || typeof endpoint !== "string") {
            results.push({
              endpoint: testCase.endpoint,
              body: testCase.body,
              testCase: testCase.testCase,
              success: false,
              expectedStatus: testCase.expectedStatusCode,
              actualStatus: null,
              effectiveStatus: null,
              responseData: null,
              error: "Invalid endpoint provided",
            });
            continue; // Skip this test case
          }

          const updatedUrl = ConstructUrl(baseUrl, testCase);
          let fullUrl = updatedUrl?.fullUrl;

          try {
            const backendUrl = `${API_BACKEND_URL}/test?companyId=${user.companyid}`;

            const safeJsonParse = (jsonString, fallback = {}) => {
              if (!jsonString || jsonString.trim() === "") return fallback;
              try {
                if (typeof jsonString === "object") return jsonString;
                return JSON.parse(jsonString);
              } catch (error) {
                console.warn("Failed to parse JSON:", error);
                return fallback;
              }
            };

            const parsedPathParams = safeJsonParse(testCase.pathParams || "{}", {});
            let finalUrl = fullUrl || "";
            if (parsedPathParams && Object.keys(parsedPathParams).length > 0) {
              Object.entries(parsedPathParams).forEach(([key, value]) => {
                finalUrl = finalUrl.replace(new RegExp(`\\{${key}\\}`, "g"), encodeURIComponent(value));
                finalUrl = finalUrl.replace(
                  new RegExp(`:${key}(?=\\/|$)`, "g"),
                  encodeURIComponent(value),
                );
              });
            }

            const requestBody = {
              method: httpMethod || "",
              url: finalUrl,
              headers: safeJsonParse(testCase.headers || "{}", {}),
              queryParams: safeJsonParse(testCase.queryParams || "{}", {}),
              pathParams: parsedPathParams,
              body: testCase.body || "",
              apiName: testCase.testCase || "",
              id: testCase.id || -1,
              expectedStatusCode: testCase.expectedStatusCode,
              requestKeyValuePairs: {},
              endpointId: testCase.endpointId || null,
              bodyType: testCase.bodyType || "json",
              bodySubType: testCase.bodySubType || "json",
            };

            const response = await apiFetch(backendUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody),
            });

            const data = await response?.json();

            if (data.error || data.message) {
              results.push({
                testCase: testCase.testCase,
                endpoint: testCase.endpoint,
                body: testCase.body,
                success: false,
                expectedStatus: testCase.expectedStatusCode,
                actualStatus: response.status,
                effectiveStatus: response.status,
                responseData: JSON.stringify(data, null, 2),
                error: data.error || data.message,
              });
            } else {
              const actualStatus = data.originalResponse?.status || response.status;
              const responseData = data.originalResponse || data;

              results.push({
                testCase: testCase.testCase,
                endpoint: testCase.endpoint,
                body: testCase.body,
                success: matchesExpectedStatus(actualStatus, testCase.expectedStatusCode),
                expectedStatus: testCase.expectedStatusCode,
                actualStatus: actualStatus,
                effectiveStatus: actualStatus,
                responseData:
                  typeof responseData === "object"
                    ? JSON.stringify(responseData, null, 2)
                    : responseData,
                error: null,
              });
            }
          } catch (err) {
            results.push({
              testCase: testCase.testCase,
              endpoint: testCase.endpoint,
              body: testCase.body,
              success: false,
              expectedStatus: testCase.expectedStatusCode,
              actualStatus: null,
              effectiveStatus: null,
              responseData: null,
              error: err.message,
            });
          }
          // await new Promise((resolve) => setTimeout(resolve, 500)); // Optional delay between requests
        }

        setProgress(100);
        storeTestCaseResult(results);
        const reportUrl = generateHtmlReport(results);
        setTestReport(reportUrl);
        handleTestComplete(results, reportUrl);
        return results;
      } catch (err) {
        console.error("Bulk request error:", err);
        throw err;
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="font-apple bg-white h-full max-h-[100vh] overflow-hidden flex flex-col">
      <style>{loaderStyles}</style>

      <div className="flex-shrink-0 p-4 border-b border-gray-200">
        <div className="flex gap-4">
          {!showTable && (
            <button
              onClick={() => setShowTable(true)}
              className="cursor-pointer text-black bg-blue-100 px-4 py-2 text-sm font-medium rounded transition-colors hover:bg-blue-200"
            >
              Show Test table
            </button>
          )}

          {showTable && testResults && testResults.length > 0 && (
            <button
              onClick={() => setShowTable(false)}
              className="cursor-pointer text-black bg-blue-100 px-4 py-2 text-sm font-medium rounded transition-colors hover:bg-blue-200"
            >
              Show Test summary
            </button>
          )}
        </div>

        <div className="flex items-center gap-2 mt-4">
          <FormControl size="small" style={{ minWidth: 160 }}>
            <InputLabel>Sort By</InputLabel>
            <Select value={sortBy} onChange={(e) => setSortBy(e.target.value)} label="Sort By">
              <MenuItem value=" ">Default</MenuItem>
              <MenuItem value="createdAt">Created Date</MenuItem>
              <MenuItem value="modifiedAt">Modified Date</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel style={{ background: "white" }}>Collection</InputLabel>
            <Select
              value={collectionfilter}
              onChange={(e) => {
                setcollectionfilter(e.target.value);
                // The predicate must return a boolean: returning obj.endpoints meant a collection
                // with no endpoints never matched, and reading .endpoints off undefined threw.
                const selectedOption = latestResults?.collections?.find(
                  (obj) => obj.id === e.target.value,
                );
                setEndcase(selectedOption?.endpoints || []);
                setSearchQuery("");
              }}
              sx={{
                fontSize: "14px",
                fontFamily: "inherit",
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiSelect-select": {
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#3b82f6",
                  borderWidth: "1px",
                },
                backgroundColor: "white",
              }}
            >
              {(latestResults?.collections ?? []).map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel style={{ background: "white" }}>End Point</InputLabel>
            <Select
              value={endPoint}
              onChange={(e) => {
                setEndpoint(e.target.value);
                fetchTestCases({ endpointId: e.target.value });
              }}
              sx={{
                fontSize: "14px",
                fontFamily: "inherit",
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiSelect-select": {
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#3b82f6",
                  borderWidth: "1px",
                },
                backgroundColor: "white",
              }}
            >
              {(endCase ?? []).map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name ? option.name : option.path}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel style={{ background: "white" }}>Method Filter</InputLabel>
            <Select
              value={searchType}
              onChange={(e) => {
                setSearchType(e.target.value);
                setSearchQuery("");
              }}
              sx={{
                fontSize: "14px",
                fontFamily: "inherit",
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiSelect-select": {
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#3b82f6",
                  borderWidth: "1px",
                },
                backgroundColor: "white",
              }}
            >
              <MenuItem
                value="priority"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Priority
              </MenuItem>
              <MenuItem
                value="type"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Type
              </MenuItem>
              {/* <MenuItem
                value="collection"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Collection
              </MenuItem> */}
              <MenuItem
                value="Code"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Status Code
              </MenuItem>
              <MenuItem
                value="Tags"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Tags
              </MenuItem>
              <MenuItem
                value="Methods"
                sx={{
                  fontSize: "14px",
                  fontFamily: "inherit",
                }}
              >
                Filter by Methods
              </MenuItem>
            </Select>
          </FormControl>

          {/* <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={`Search by ${searchType}...`}
            className="px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500 flex-1 min-w-0 max-w-xl"
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
          /> */}
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel style={{ background: "white" }}>Filter Options</InputLabel>
            <Select
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                fontSize: "14px",
                fontFamily: "inherit",
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiSelect-select": {
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#3b82f6",
                  borderWidth: "1px",
                },
                backgroundColor: "white",
              }}
            >
              {(options?.[searchType] ?? []).map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <button
            onClick={handleSearch}
            disabled={isSearchLoading || searchQuery.trim() === ""}
            className="px-4 py-2 cursor-pointer text-sm bg-green-100 hover:bg-green-200 disabled:bg-gray-100 disabled:cursor-not-allowed rounded transition-colors"
          >
            {isSearchLoading ? "Searching..." : "Search"}
          </button>

          {filteredTestCases && (
            <button
              onClick={clearSearch}
              className="px-4 cursor-pointer py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded transition-colors"
            >
              Clear
            </button>
          )}
          <button
            onClick={() => handleBulkRequests(allData)}
            className="cursor-pointer text-black bg-blue-100 px-4 py-2 text-sm font-medium rounded transition-colors hover:bg-blue-200"
          >
            {runbutton}
          </button>
        </div>

        {/* Search Results Info */}
        {filteredTestCases && (
          <div className="mt-2 text-sm text-gray-600">
            Found {filteredTestCases.length} test case(s) matching the filters
          </div>
        )}
      </div>

      {/* Status and loading indicators */}
      {status.isGenerating && (
        <div className="flex-shrink-0 p-8 rounded-lg w-full flex items-center justify-center bg-gray-50 m-4">
          <Loader2 description={status.currentEndpoint} />
        </div>
      )}

      {isLoading && (
        <div className="flex-shrink-0 p-4 border-b border-gray-200">
          <Box sx={{ width: "100%" }}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ height: 10, borderRadius: 1 }}
            />
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Testing: {currentTest} ({Math.floor((progress / 100) * (allData?.length || 0))}/
              {allData?.length || 0})
            </Typography>
          </Box>
        </div>
      )}

      {/* Main content area */}
      <div className="flex-1 overflow-hidden relative">
        {allData && !showTable && (
          <>
            {selectedTestCases.length > 0 && (
              <div className="absolute top-4 right-4 z-10">
                <button
                  onClick={handleExecuteSelected}
                  className="cursor-pointer text-black bg-blue-100 px-6 py-3 text-sm font-medium rounded transition-colors hover:bg-blue-200"
                >
                  Run Selected Tests
                </button>
              </div>
            )}

            <div className="h-full overflow-y-auto p-6 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 hover:scrollbar-thumb-gray-500">
              <BulkApiTester results={testResults} testReport={testReport} />
            </div>
          </>
        )}

        {allData && showTable && (
          <div className="h-full overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 hover:scrollbar-thumb-gray-500">
            <div className="px-6 py-3 border-b border-gray-200 bg-gray-50 flex items-center gap-3 flex-wrap">
              <span className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold font-apple">
                Review in Excel
              </span>
              <TestCaseExcelPanel
                collectionId={collectionfilter || null}
                endpointId={endPoint || null}
                companyId={user?.companyid}
                onImported={fetchAllTestCases}
              />
            </div>
            <TestCasesTable
              testCases={
                searchType !== "" || endPoint !== ""
                  ? filteredTestCases?.length > 0
                    ? filteredTestCases
                    : [] // show empty array if search returns nothing
                  : allData
              }
              testResults={testResults}
              selectedTestCases={selectedTestCases}
              onTestCaseSelect={handlTestCaseSelect}
              onMarkAsReviewed={handleMarkAsReviewed}
              onSaveTestCase={handleSaveTestCase}
              fetchAllTestCases={fetchAllTestCases}
              sortBy={sortBy}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExecutionTab;
